import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import { isType, isTypeBK, localeTw, userTypeList } from 'main_consts';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import '../../../index.scss';

// material
import Button from '@material-ui/core/Button';
import Header from 'components/Header';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// ICON

import AttachFileIcon from '@material-ui/icons/AttachFile';
import EditIcon from '@material-ui/icons/Edit';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import SaveIcon from '@material-ui/icons/Save';
import SearchIcon from '@material-ui/icons/Search';
// other
import { GridColDef } from '@material-ui/data-grid';
import colW from 'components/NewTable/consts';
import { RenderCellParam, TableColumn } from 'components/NewTable/type';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
// component
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import Input from '../../../components/Material/Input';
import Menu from '../../../components/Menu';
import {
  blobDownload,
  IGetDownloadExpTaxRecpSet,
  postExcelExpTaxRecpSet,
  postExportTmpExcelFile,
  postSaveExpTaxRecpSet,
  postSearch,
  postUploadExcelExpTaxRecpSet,
  snackBarRsp,
} from '../../../main_api';
import {
  EhuFunctionChkResult,
  formatDate,
  formatDateTime,
  getDateDayPlus,
  getEhuFunctionChk,
  getExpressName,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  radioChange,
} from '../../../main_func';

// import Table from '../../../components/Material/Table/index';

import Radio from '../../../components/Radio';
import { Iobject } from '../../../main_type';
import QryInput from './QryInput';
import { Imaster, Iresult, ISearchData } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);

/** 稅單收據資料設定 */
const ExpTaxRecpSet = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 記帳代號
    chkCode1: '',
    chkCode3: '',
    // 業者名稱
    expressCnName: '',
    // 主號
    mawbNo: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    endDateValid: false,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
    qryType: '1',
    boxNo: '',
    qryOK: false,

    qryInputType1: '1',
    qryInputType2: '1',
    qryInputType3: '1',
    qryInputType4: '1',
    qryInputType5: '1',
    qryInputType6: '1',
    qryInputType7: '1',
    qryInputType8: '1',
    qryInputType9: '1',
    qryInputType10: '1',

    mawb1: '',
    mawb2: '',
    mawb3: '',
    mawb4: '',
    mawb5: '',
    mawb6: '',
    mawb7: '',
    mawb8: '',
    mawb9: '',
    mawb10: '',

    hawb1: '',
    hawb2: '',
    hawb3: '',
    hawb4: '',
    hawb5: '',
    hawb6: '',
    hawb7: '',
    hawb8: '',
    hawb9: '',
    hawb10: '',

    dutyNo1: '',
    dutyNo2: '',
    dutyNo3: '',
    dutyNo4: '',
    dutyNo5: '',
    dutyNo6: '',
    dutyNo7: '',
    dutyNo8: '',
    dutyNo9: '',
    dutyNo10: '',
  };
  const apiName = 'expTaxRecpSet';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<Iresult[]>([]);

  function onCellEditingStartedEvent(event: any) {
    // console.log('onCellEditingStarted(local):', event);
    switch (event.colDef.field) {
      case 'defDutyCode':
      case 'defDutyMark1':
      case 'defDutyMark2':
        setTimeout(() => {
          if (event.data.saveFlag !== 'Y') {
            event.api.stopEditing(true);
            // console.log(
            //   'onCellEditingStarted(stopEditing):',
            //   event.data.sortSeq
            // );
          }
        }, 0);
        break;
      default:
        break;
    }
  }

  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = [
      {
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        minWidth: 65,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '稅單號碼',
        field: 'dutyNo',
      },
      {
        headerName: '主號',
        field: 'mawbNo',
      },
      {
        headerName: '分號',
        field: 'hawbNo',
      },
      {
        headerName: '件數',
        field: 'totPackageNumber',
      },
      {
        headerName: '營業稅稅基',
        field: 'taxBasis',
      },
      {
        headerName: '金額',
        field: 'totDutyAmt',
      },
      {
        headerName: '授權統編',
        field: 'defDutyCode',
        editable: true,
        cellStyle: (params) => {
          if (params && params.data.saveFlag === 'Y') {
            return {
              backgroundColor: '#F0F0F0',
              borderColor: '#ADADAD',
              borderWidth: '2px',
            };
          }
          return {
            backgroundColor: '#FFFFFF',
            borderColor: '#ADADAD',
            borderWidth: '0px',
          };
        },
      },
      {
        headerName: '自定義欄1',
        field: 'defDutyMark1',
        editable: true,
        cellStyle: (params) => {
          if (params && params.data.saveFlag === 'Y') {
            return {
              backgroundColor: '#F0F0F0',
              borderColor: '#ADADAD',
              borderWidth: '2px',
            };
          }
          return {
            backgroundColor: '#FFFFFF',
            borderColor: '#ADADAD',
            borderWidth: '0px',
          };
        },
      },
      {
        headerName: '自定義欄2',
        field: 'defDutyMark2',
        editable: true,
        cellStyle: (params) => {
          if (params && params.data.saveFlag === 'Y') {
            return {
              backgroundColor: '#F0F0F0',
              borderColor: '#ADADAD',
              borderWidth: '2px',
            };
          }
          return {
            backgroundColor: '#FFFFFF',
            borderColor: '#ADADAD',
            borderWidth: '0px',
          };
        },
        // cellStyle: { backgroundColor: '#FFFF6F' },
        // valueFormatter: (d) => {
        //   if (d && d.value) {
        //     return roleStatusOpTrs.trans[d.value] || ' ';
        //   } else {
        //     return ' ';
        //   }
        // },
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          // if (params && params.data.processDesc === '比對不符') {
          //   return { fontWeight: 'bold', color: 'red' };
          // } else {
          //   return { fontWeight: 'initial', color: 'black' };
          //   // return undefined; //
          // }
          // console.log(params.data.processDesc);
          if (
            params &&
            (params.data.processDesc === '處理成功!' ||
              params.data.processDesc === '資料無異動')
          ) {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 20,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,

      onCellEditingStarted: onCellEditingStartedEvent,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const [randomValue, setRandomValue] = useState(Math.random());

  const [EhuFunctionChk, setEhuFunctionChkResult] =
    useState<EhuFunctionChkResult>({
      aspUserId: '',
      userName: '',
      usertype: '',
      locationCode: '',
      boxNo: '',
      ban: '',
      asType: '',
      chkCode1: '',
      chkCode2: '',
      chkCode3: '',
      userId: '',
      updTime: '',
      roleType: '',
      sender_id: '',
      uvFlag: '',
      boxno1: '',
    });
  const [searchPara, setSearchPara] = useState<ISearchData>({
    qryType: '1',
    chkCode3: '',
    importStartDate: '',
    importEndDate: '',
    gcoStartDate: '',
    gcoEndDate: '',
    mawbNo: '',
    mawbNoAndHawbNoList: [{ mawbNo: '', hawbNo: '' }],
    dutyNoList: [],
  });
  const [QueryOK, setQueryOK] = useState(false);
  // table
  const [tbSelectList, setTbSelectList] = useState<string[]>([]);
  const [enableSave, setEnableSave] = useState<string>('N');

  useEffect(() => {
    getEhuFunctionChk().then((item) => {
      setEhuFunctionChkResult(item);
      if (
        userType &&
        !(
          isType(userTypeList.admin, userType) ||
          (isTypeBK(userType) && item.roleType === '1')
        )
      ) {
        setFormError(true);
        enqueueSnackbar(`您無權限使用此功能!`);
      }
    });
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      // 1 => 主分號 2 => 稅單號碼
      const type1Result: { mawbNo: string; hawbNo: string }[] = [];
      const type2Result: string[] = [];
      if (master.qryType === '2') {
        for (let i = 1; i <= 10; i += 1) {
          if (master[`qryInputType${i}`] === '1') {
            if (
              (master[`mawb${i}`] as string).length > 0 ||
              (master[`hawb${i}`] as string).length > 0
            ) {
              type1Result.push({
                mawbNo: master[`mawb${i}`] as string,
                hawbNo: master[`hawb${i}`] as string,
              });
            }
          } else if ((master[`dutyNo${i}`] as string).length > 0) {
            type2Result.push(master[`dutyNo${i}`] as string);
          }
        }
      }

      const para: IGetDownloadExpTaxRecpSet = {
        ...searchPara,
        qryType: master.qryType,
        chkCode3: EhuFunctionChk.chkCode3,
        importStartDate:
          master.qryType === '1'
            ? formatDate(master.startDate, 'yyyyMMdd')
            : '',
        importEndDate:
          master.qryType === '1' ? formatDate(master.endDate, 'yyyyMMdd') : '',
        gcoStartDate:
          master.qryType === '4'
            ? formatDateTime(master.startDate, `${master.startTime}00`)
            : '',
        gcoEndDate:
          master.qryType === '4'
            ? formatDateTime(master.endDate, `${master.endTime}59`)
            : '',
        mawbNo: master.qryType === '3' ? master.mawbNo : '',
        mawbNoAndHawbNoList: type1Result,
        dutyNoList: type2Result,
      };

      const result = await postExcelExpTaxRecpSet(para);
      const startDate = formatDateTime(
        master.startDate,
        master.startTime,
        'MMdd'
      );
      const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

      blobDownload(
        result,
        enqueueSnackbar,
        `${EhuFunctionChk.aspUserId}_${
          master.qryType === '1' || master.qryType === '4'
            ? `${formatDate(master.startDate, 'MMdd')}_${formatDate(
                master.endDate,
                'MMdd'
              )}`
            : formatDate(getDateDayPlus(), 'MMdd')
        }_稅單收據資料設定查詢.xlsx`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUpload = async (
    file: File,
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    await gridRef.current?.api.stopEditing(true);

    const formData = new FormData();
    formData.append('execlFile', file);

    const result = await postUploadExcelExpTaxRecpSet(apiName, formData);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    const {
      expTaxRecpSetDetails: expTaxRecpSetDetailsTemp,
      enableSave: enableSaveTemp,
    } =
      (dataTemp as {
        expTaxRecpSetDetails: unknown | unknown[];
        enableSave: string;
      }) || {};
    const data = expTaxRecpSetDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave('N');
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案

    if (file) {
      handleUpload(file);
    }
    e.target.value = '';
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    await gridRef.current?.api.stopEditing(true);

    // 1 => 主分號 2 => 稅單號碼
    const type1Result: { mawbNo: string; hawbNo: string }[] = [];
    const type2Result: string[] = [];
    if (master.qryType === '2') {
      for (let i = 1; i <= 10; i += 1) {
        if (master[`qryInputType${i}`] === '1') {
          if (
            (master[`mawb${i}`] as string).length > 0 ||
            (master[`hawb${i}`] as string).length > 0
          ) {
            type1Result.push({
              mawbNo: master[`mawb${i}`] as string,
              hawbNo: master[`hawb${i}`] as string,
            });
          }
        } else if ((master[`dutyNo${i}`] as string).length > 0) {
          type2Result.push(master[`dutyNo${i}`] as string);
        }
      }
    }

    // console.log(master.qryType);
    // console.log(EhuFunctionChk.chkCode3);
    // console.log(master.startDate);
    // console.log(master.endDate);
    // console.log(master.startTime);
    // console.log(master.endTime);
    // console.log(master.mawbNo);
    // console.log('test');
    // console.log(EhuFunctionChk);

    const result = await postSearch(apiName, {
      qryType: master.qryType,
      chkCode3: EhuFunctionChk.chkCode3,
      importStartDate: formatDate(master.startDate, 'yyyyMMdd'),
      importEndDate: formatDate(master.endDate, 'yyyyMMdd'),
      gcoStartDate: formatDateTime(master.startDate, `${master.startTime}00`),
      gcoEndDate: formatDateTime(master.endDate, `${master.endTime}59`),
      mawbNo: master.mawbNo,
      mawbNoAndHawbNoList: type1Result,
      dutyNoList: type2Result,
    });

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    const {
      expTaxRecpSetDetails: expTaxRecpSetDetailsTemp,
      enableSave: enableSaveTemp,
    } =
      (dataTemp as {
        expTaxRecpSetDetails: unknown | unknown[];
        enableSave: string;
      }) || {};
    const data = expTaxRecpSetDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);

      const allColumnIds: string[] = [];
      gridOptions.columnApi?.getAllColumns()?.forEach((colName) => {
        allColumnIds.push(colName.getColId());
      });
      gridOptions.columnApi?.autoSizeColumns(allColumnIds);
    } else {
      setEnableSave('N');
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (
      !master.endDateValid ||
      !master.endTimeValid ||
      !master.startDateValid ||
      !master.startTimeValid ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    let canQry: boolean;
    canQry = false;
    switch (master.qryType) {
      case '2':
        for (let i = 1; i <= 10; i += 1) {
          if (master[`qryInputType${i}`] === '1') {
            if (
              (master[`mawb${i}`] as string).length > 0 &&
              (master[`hawb${i}`] as string).length > 0
            ) {
              canQry = true;
            }
          } else if ((master[`dutyNo${i}`] as string).length > 0) {
            canQry = true;
          }
        }
        if (!canQry) {
          enqueueSnackbar(`至少要輸入一筆主分號/稅單號碼!`);
        }
        break;
      case '3':
        if (master.mawbNo.trim() !== '') {
          canQry = true;
        } else {
          enqueueSnackbar('【主號】必填。', {
            variant: 'warning',
          });
        }
        break;
      default:
        canQry = true;
        break;
    }

    if (!canQry) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    // const selectedNodes = gridRef.current.api.getSelectedNodes();
    // if (selectedNodes && selectedNodes.length === 0) {
    //   // this.common.messageBox('請先選擇一筆要刪除的資料!', '批次刪除');
    // } else {
    //   console.log(selectedNodes);
    // }

    await gridRef.current?.api.stopEditing(true);
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setQueryOK(false);
    setEnableSave('N');
  };
  const handleSave = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    // setTimeout(() => {
    //   gridRef.current.api.stopEditing(false);
    // }, 0);
    await gridRef.current.api.stopEditing(false);
    // console.log(rowData);

    const result = await postSaveExpTaxRecpSet(apiName, rowData);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;

    const {
      expTaxRecpSetDetails: expTaxRecpSetDetailsTemp,
      enableSave: enableSaveTemp,
    } =
      (dataTemp as {
        expTaxRecpSetDetails: unknown | unknown[];
        enableSave: string;
      }) || {};
    const data = expTaxRecpSetDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(enableSaveTemp);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave('N');
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const downloadExample = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));

      const result = await postExportTmpExcelFile('');

      blobDownload(result, enqueueSnackbar, `稅單設定上傳格式範本.xlsx`);
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            稅單資料查詢
          </Link>
          <Typography color="textPrimary">稅單收據資料設定</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon />
            稅單收據資料設定
          </div>
        </div>
        <div className="input-area">
          {EhuFunctionChk.chkCode3 === 'Y' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*查詢選項：</FormTitle>
              </VcEGrid>
              <HVcGrid item xs={12} sm={6}>
                <Radio
                  className="input-radio "
                  required
                  name="qryType"
                  value={master.qryType}
                  onChange={radioChange(updateData)}
                  options={[
                    { value: '1', label: '進口日期區間' },
                    { value: '2', label: '主分號/稅單號碼' },
                    { value: '3', label: '主號' },
                    {
                      value: '4',
                      label: '出倉日期區間',
                    },
                  ]}
                />
              </HVcGrid>
            </Grid>
          )}

          {EhuFunctionChk.chkCode3 !== 'Y' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*查詢選項：</FormTitle>
              </VcEGrid>
              <HVcGrid item xs={12} sm={6}>
                <Radio
                  className="input-radio "
                  required
                  name="qryType"
                  value={master.qryType}
                  onChange={radioChange(updateData)}
                  options={[
                    { value: '1', label: '進口日期區間' },
                    { value: '2', label: '主分號/稅單號碼' },
                    { value: '3', label: '主號' },
                  ]}
                />
              </HVcGrid>
            </Grid>
          )}
          {master.qryType === '1' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {master.qryType === '1' ? '日期區間：' : '日期區間'}
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
                <DateSePickersTyping
                  required
                  updateData={updateData}
                  style={{ maxWidth: 600 }}
                  names={['startDate', 'endDate']}
                  data={master}
                  seInterval={31}
                />
              </VcGrid>
            </Grid>
          )}

          {master.qryType === '2' && (
            <>
              <QryInput
                index="1"
                value={{
                  mawbVal: master.mawb1,
                  hawbVal: master.hawb1,
                  dutyNoVal: master.dutyNo1,
                  qryInputType: master.qryInputType1,
                }}
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb2,
                  hawbVal: master.hawb2,
                  dutyNoVal: master.dutyNo2,
                  qryInputType: master.qryInputType2,
                }}
                index="2"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb3,
                  hawbVal: master.hawb3,
                  dutyNoVal: master.dutyNo3,
                  qryInputType: master.qryInputType3,
                }}
                index="3"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb4,
                  hawbVal: master.hawb4,
                  dutyNoVal: master.dutyNo4,
                  qryInputType: master.qryInputType4,
                }}
                index="4"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb5,
                  hawbVal: master.hawb5,
                  dutyNoVal: master.dutyNo5,
                  qryInputType: master.qryInputType5,
                }}
                index="5"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb6,
                  hawbVal: master.hawb6,
                  dutyNoVal: master.dutyNo6,
                  qryInputType: master.qryInputType6,
                }}
                index="6"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb7,
                  hawbVal: master.hawb7,
                  dutyNoVal: master.dutyNo7,
                  qryInputType: master.qryInputType7,
                }}
                index="7"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb8,
                  hawbVal: master.hawb8,
                  dutyNoVal: master.dutyNo8,
                  qryInputType: master.qryInputType8,
                }}
                index="8"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb9,
                  hawbVal: master.hawb9,
                  dutyNoVal: master.dutyNo9,
                  qryInputType: master.qryInputType9,
                }}
                index="9"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb10,
                  hawbVal: master.hawb10,
                  dutyNoVal: master.dutyNo10,
                  qryInputType: master.qryInputType10,
                }}
                index="10"
                fatherUpdateData={updateData}
              />
            </>
          )}
          {master.qryType === '3' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                主號：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="mawbNo"
                  value={master.mawbNo}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}

          {master.qryType === '4' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>出倉日期區間：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={31}
                />
              </VcGrid>
            </Grid>
          )}
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={enableSave !== 'Y' || formError}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => handleSave()}
            >
              確定
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <input
              disabled={formError}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              className={classes.input}
              id="contained-button-file"
              // multiple
              type="file"
              onChange={selectFile}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={formError}
                variant="contained"
                color="default"
                startIcon={<AttachFileIcon />}
                component="span"
                style={{
                  borderRadius: '20px',
                  // backgroundColor: 'blue',
                }}
              >
                上傳Excel
              </Button>
            </label>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => downloadExample()}
            >
              下載EXCEL格式範本
            </Button>
          </Grid>
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          1.上傳Excel的檔案格式，請務必與下載Excel檔格式相同。
        </div>

        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          2.查詢選項為:主分號/稅單號碼可編輯授權統編和自定義欄位。
        </div>

        <span
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          3.滑鼠指到欲排序欄位同時按壓「Ctrl」鍵，即可達成排序效果。
        </span>
      </form>
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};
export default ExpTaxRecpSet;
